import moment from "moment"

export default {
  "loginForm": {
    "username": "Número de teléfono o Correo electrónico",
    "password": "Contraseña",

    "usernamePlaceholder": "Teléfono con código de país o correo electrónico",
    "passwordPlaceholder": "Contraseña",

    "phoneExample": "Ex: +62896123465659"
  },

  "passwordResetForm": {
    "email": "Email",

    "emailPlaceholder": "Ingrese su correo electrónico"
  },

  "farmForm": {
      "farmTooltip": "Escriba el nombre de su granja aquí",
      "farmTooltip2": "Escriba aquí la dirección de su finca",
      "farmTooltip3": "Anote aquí los datos de su granja",

      "name": "Nombre de la Granja",
      "area": "Area (m²)",
      "countryId": "País",
      "regionId": "Ciudad o Distrito",
      "currencyId": "Divisa",
      "timezone": "Zona horaria",
      "provinceId": "Provincia",
      "regencyId": "Ciudad",
      "districtId": "Distrito",
      "villageId": "Sub Distrito",
      "address": "Dirección",

      "namePlaceholder": "Nombre de la Granja",
      "areaPlaceholder": "-",
      "countryIdPlaceholder": "Seleccione País",
      "provinceIdPlaceholder": "Seleccione Provincia",
      "regencyIdPlaceholder": "Seleccione Ciudad",
      "districtIdPlaceholder": "Seleccione Distrito",
      "villageIdPlaceholder": "Seleccione Sub Distrito",
      "addressPlaceholder": "Nombre del bloque, nombre de la calle, otra información",
      "regionIdPlaceholder": "Seleccione Ciudad o Distrito",
      "currencyIdPlaceholder": "Seleccione Divisa",
      "timezonePlaceholder": "Seleccione Zona horaria",

      "deleteSubtitle": "El ciclo de datos, el estanque y la granja se eliminarán y no podrá volver a acceder a ellos.",
      "createFarm": "Crear granja"
    },

    "pondForm": {
      "farmId": "Granja",
      "title": "Crear estanque(s) para",
      "totalPonds": "Estanques Totales",
      "namePrefix": "Nombre de Estanque(s)",
      "name": "Nombre del Estanque",
      "type": "Tipo de Estanque",
      "length": "Longitud (m)",
      "width": "Ancho (m)",
      "area": "Ancho (m²)",
      "deep": "Profundidad (m)",
      "diameter": "Diámetro del Estanque (m)",

      "farmIdPlaceholder": "-",
      "totalPondsPlaceholder": " ",
      "namePrefixPlaceholder": " ",
      "namePlaceholder": " ",
      "typePlaceholder": " ",
      "lengthPlaceholder": " ",
      "widthPlaceholder": " ",
      "areaPlaceholder": " ",
      "deepPlaceholder": " ",

      "namePrefixHelper": "Los numeros de estanques se generan automáticamente por el total de estanques",

      "totalPondsMaxMessage": "El máximo de la versión gratuita es de %{max} estanques. Para mas, puedes agregarlos desde la aplicación web.",

      "pond": "Estanque",
      "formTitle": "Lista de Estanques",
      "formSubtitle": "Cambie el área del estanque al tamaño real para que el sistema de estimación sea más adecuado."
    },

    "cycleForm": {
      "id": "Ciclo",
      "farmId": "Granja",
      "pondId": "Estanque",
      "totalSeed": "Larvas Totales (cola)",
      "totalSeedType": "Tipo de semilla total",
      "startedAt": "Empezó a Las",
      "finishedAt": "terminado en",
      "initialAge": "Edad Inicial (día)",
      "preparationDay": "Día de preparación (días)",
      "hatcheryId": "Hatchery",
      "speciesId": "Species",
      "broodStockProductId": "Broodstock",
      "minimumFr": "La tabla Fr no está completa. Tabla Fr completa hasta 60 aquí",
      "warning": "Advertencia: Cambiar la fecha de inicio puede modificar el día de cultivo y puede afectar el cálculo de la estimación.",
      "cycleTooltip": "Anote el ciclo aquí",

      "idPlaceholder": "Seleccione Ciclo",
      "farmIdPlaceholder": "Seleccione Granja",
      "pondIdPlaceholder": "Seleccione Estanque",
      "totalSeedPlaceholder": "Larvas Totales",
      "totalSeedTypePlaceholder": "Seleccione larva",
      "startedAtPlaceholder": "Empezó a las",
      "finishedAtPlaceholder": "terminado en",
      "initialAgePlaceholder": "Opcional",
      "preparationPlaceholder": "Opcional",
      "hatcheryIdPlaceholder": "Seleccionar planta de incubación",
      "speciesIdPlaceholder": "Seleccionar especie",
      "broodStockProductIdPlaceholder": "Seleccionar broodstock",
      "feedingTrayCountPlaceholder": "Canasta de alimentación",
      "limitWeightPerAreaPlaceholder": " ",
      "targetCultivationDayPlaceholder": " ",
      "targetSizePlaceholder": " ",
      "targetSurvivalRatePlaceholder": " ",
      "areaPlaceholder": " ",
      "deepPlaceholder": " ",
      "survivalRatePredictionMethodPlaceholder": "Seleccione el método de predicción de TS",
      "remarkPlaceholder": "Notas",

      "initialAgeHelper": "Edad inicial a las que comenzó a las",
      "targetSizeHelper": "DdC 100",


      "cycleClose": "Cerrar ciclo",
      "targetAndCycles": "Ciclo objetivo e información",
      "targetSubtitle": "Llene este registro de acuerdo a su plan para asegurarse de que el cálculo y la predicción de Jala sean óptimos.",
      "nextPond": "siguiente estanque",

      "net": "Neto",
      "gross": "Bruto",
      "actual": "Real",
      "netNote": "Cantidad que ordenó",
      "grossNote": "Cantidad recibida del laboratorio",
      "actualNote": "Cantidad real contabilizada",

      "fr": "Relación de alimentación",
      "fixed": "Fijo",
      "ai": "Por Medidas",
      "customFr": "Mesa FR personalizada",
      "stpFr": "Tabla FR STP",
      "adg": "ADG",
      "aiCultivation": "Proporción de alimentación, bandeja de alimentación, mortalidad",

      "cycle": "Ciclo",
      "createCycle": "Crear ciclo",
      "updateCycle": "Ahorrar",
      "pond": "Estanque",
      "pondPlaceholder": "Seleccionar estanque",
      "seed": "semilla total (piezas)",
      "seedPlaceholder": "Semilla total",
      "type": "Tipo de semilla",
      "typePlaceholder": "Seleccione...",
      "hatchery": "Criadero",
      "hatcheryPlaceholder": "Seleccione...",
      "spread": "Fecha de propagación",
      "spreadPlaceholder": "Seleccione...",
      "species": "Especies",
      "speciesPlaceholder": "Seleccione...",
      "tray": "Bandeja de alimentación total",
      "trayPlaceholder": "Bandeja",
      "biomass": "Capacidad de carga (kg/m²)",
      "biomassPlaceholder": "Biomasa",
      "targetDay": "Objetivo agrícola (días)",
      "targetDayPlaceholder": "Objetivo agrícola",
      "targetSize": "Contar objetivo",
      "targetSr": "Objetivo de RS (%)",
      "area": "Área (m²)",
      "deep": "Profundidad (m)",
      "notes": "Notas",
      "notesPlaceholder": "Notas",
      "feedingTrayCount": "Número total de comederos",
      "limitWeightPerArea": "Traer capacidad (kg/m²)",
      "targetCultivationDay": "Cultivar el viejo objetivo (día)",
      "targetSurvivalRate": "SR Objetivo (%)",
      "survivalRatePredictionMethod": "SR método de predicción",
      "remark": "Notas (Opcional)",

      "feedPrice": "Precio del Pienso (para la estimación de costos de producción)",
      "feedPricePlaceholder": "Precio del alimento",
    },

    "farmShrimpPriceForm": {
      "farmId": "Granja",
      "shrimpPriceId": "Selecciona Ubicación y Precio",
      "shrimpPriceIdPrivate": "Selecciona Ubicación y Precio de Referencia (opcional)",
      "shrimpPriceSubtitle": "Puede seleccionar una ubicación de precio de referencia o crear su propio precio personal",

      "farmIdPlaceholder": "Seleccione Granja",
      "shrimpPriceIdPlaceholder": "Selecciona Ubicación y Precio",
      "shrimpPriceIdPrivatePlaceholder": "Elija Referencia",

      "title": "Fijar el precio de su cosecha con el precio real del camarón",
      "subtitle": "Conecte los últimos precios del camarón con su granja. Jala calculará automáticamente el cálculo del precio de venta en función del precio elegido.",
      "helperText": "*Precio de Talla 100 pzs/kg basado en la fecha de inicio de su último ciclo en %{date}",
      "privateHelperText": "*Última actualización del precio privado del camarón por: %{user} en : %{date}",

      "source": "Fuente de precio de venta",
      "newest": "Nuevo precio de camarones",
      "private": "Precio privado de camarones",
      "createNew": "Crear Nuevo",

      "privateFormTitle": "Crear precio privado de camarones",
      "location": "Ubicación de la granja",
      "locationPlaceholder": "Ubicación de entrada",
      "currency": "Divisa",
      "delete": "Eliminar precio privado de camarones?",
      "info": "Puede vaciar el formulario si no tiene un precio, los precios privados de camarones que se guardan no aparecerán en la página pública de precios de camarones.",

      "createPrivateTitle": "Conectar la biomasa estimada con los precios del camarón",
      "createPrivateSubtitle": "Jala calculará el precio de venta de tu camarón en base a la biomasa estimada al precio del camarón seleccionado.",
      "size100Validation": "Se requiere el tamaño 100 para ser llenado",

      "deleteModalTitle": "Eliminar precio de camarón privado",
      "deleteModalSubtitle": "¿Estás seguro de eliminar los datos?",
      "emptyPrivatePriceTitle": "Los precios de los camarones privados aún no están disponibles.",
      "emptyPrivatePriceSubtitle": "Puede crear una lista privada de precios de camarones para mejorar la precisión del precio de venta estimado",
      "dropdownPrivateTitle": "Elija el precio privado de camarones",
      "sizeInput": "Precio y Tamaño",
      "createdBy": "Creado por: {{user}}",

      "privateShrimpPriceSaveTitle": "Guardar Precio Privado?",
      "privateShrimpPriceSaveSubtitle": "¿Estás seguro de que quieres ahorrar el precio privado del camarón?",
      "newestShrimpPriceSaveTitle": "Guardar el precio más nuevo?",
      "newestShrimpPriceSaveSubtitle": "¿Estás seguro de que quieres ahorrar el precio más nuevo de camarones?",
    },

    "waterQualityMultiMeasurementForm": {
      "farmId": "Granja",
      "batchId": "Lote",
      "pondId": "Estanque",
      "cycleId": "Estanque",
      "measuredDate": "Fecha Medida",
      "measuredTime": "Tiempo Medido",
      "temperature": "Temperatura (°C)",
      "ph": "pH",
      "salinity": "Salinidad (ppt)",
      "do": "OD (mg/L)",
      "transparency": "Transparencia (cm)",
      "waterLevel": "Nivel del agua (cm)",
      "doPercent": "OD Por ciento (%)",
      "turbidity": "Turbiedad (NTU)",
      "ec": "Conductividad Eléctrica (µS)",
      "color": "Color de agua",
      "weather": "Clima",
      "measurementTooltip": "Anote aquí la calidad del agua",
      "orp": "ORP (mV)",

      "farmIdPlaceholder": "Seleccione Granja",
      "batchIdPlaceholder": "Seleccione Lote",
      "pondIdPlaceholder": "Seleccione Estanque",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "measuredDatePlaceholder": "Fecha Medida",
      "measuredTimePlaceholder": "Tiempo Medido",
      "temperaturePlaceholder": "-",
      "phPlaceholder": "-",
      "salinityPlaceholder": "-",
      "doPlaceholder": "-",
      "transparencyPlaceholder": "-",
      "waterLevelPlaceholder": "-",
      "doPercentPlaceholder": "-",
      "turbidityPlaceholder": "-",
      "ecPlaceholder": "-",
      "colorPlaceholder": "Seleccionar el color",
      "weatherPlaceholder": "Seleccione Clima",
      "orpPlaceholder": "-",

      "waterQualityMultiMeasurement": "Calidad del agua",
      "otherParameters": "Otros parámetros",
      "based": "Residencia en",
      "quantity": "Cantidad (piezas)",
      "size": "Tamaño"
    },
    "feedForm": {
      "farmId": "Granja",
      "cycleId": "Estanque",
      "loggedDate": "Fecha",
      "loggedTime": "Tiempo",
      "stockId": "Valores",
      "quantity": "Alimentación (kg)",
      "fasting": "Ayuno",
      "remark": "Notas (opcional)",
      "feedTooltip": "Anote aquí los datos del Feed que proporcione",

      "farmIdPlaceholder": "Seleccione Granja",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "loggedDatePlaceholder": "Fecha de alimentación",
      "loggedTimePlaceholder": "Tiempo de alimentación",
      "stockIdPlaceholder": "Seleccione Valores",
      "quantityPlaceholder": " ",
      "remarkPlaceholder": "Nota",

      "feeding": "Alimentación"
    },
    "feedingTrayControlForm": {
      "farmId": "Granja",
      "cycleId": "Estanque",
      "loggedDate": "Fecha",
      "loggedTime": "Verificando tiempo",
      "feedLoggedAt": "Hora de Alimentacion",
      "datePlaceholder": "Fecha",
      "remark": "Notas (opcional)",
      "trayTooltip": "Anote aquí la bandeja de datos marcada",
      "remainFeed": "Seleccione alimentación restante en la bandeja",

      "feedingTray": "Canastas %{number}",

      "farmIdPlaceholder":"Seleccione Granja",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "loggedDatePlaceholder": "Seleccione fecha",
      "loggedTimePlaceholder": "Seleccione tiempo",
      "feedLoggedAtPlaceholder": "Seleccione Hora de Alimentacion",
      "remarkPlaceholder": "Nota",
      "feedingTrayControlRemark": "*Alimentación sobrante en la bandeja:",

      "feedingTrayControl": "Canasta de alimentación"
    },
    "samplingForm": {
      "farmId": "Granja",
      "cycleId": "Estanque",
      "sampledAt": "Fecha",
      "averageWeight": "PP (g)",
      "files": "Fotos",
      "remark": "Notas (opcional)",
      "sampleTooltip": "Anote los datos de muestreo aquí",

      "farmIdPlaceholder":"Seleccione Granja",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "sampledAtPlaceholder": "Fecha de muestreo",
      "averageWeightPlaceholder": " ",
      "filesPlaceholder": "Fotos",
      "remarkPlaceholder": "Nota",

      "sampling": "Muestreo"
    },
    "treatmentForm": {
      "farmId": "Granja",
      "pondId": "Estanque",
      "cycleId": "Estanque",
      "stockId": "Valores",
      "name": "Tratamiento",
      "treatedAt": "Fecha",
      "quantity": "Cantidad",
      "remark": "Notas (opcional)",
      "treatmentTooltip": "Anote los datos de tratamiento en cada estanque",

      "farmIdPlaceholder":"Seleccione Granja",
      "pondIdPlaceholder": "Seleccione Estanque",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "stockIdPlaceholder": "Seleccione Valores",
      "namePlaceholder": "Tratamiento",
      "treatedAtPlaceholder": "Seleccione fecha",
      "quantityPlaceholder": " ",
      "remarkPlaceholder": "Nota",

      "treatment": "Tratamiento",

      "recordType": "tipo de registro",
      "radioBasic": "Nota de texto",
      "radioPro": "Usando producto de tratamiento",
    },
    "harvestForm": {
      "farmId": "Granja",
      "cycleId": "Estanque",
      "harvestedAt": "Fecha",
      "status": "Tipo de cosecha",
      "weight": "Peso total (kg)",
      "size": "Talla (tail/kg)",
      "price": "Precio por kg",
      "sellingPrice": "Precio total",
      "buyer": "Comprador (Opcional)",
      "remark": "Notas (Opcional)",
      "harvestTooltip": "Anote los datos de Cosecha aquí. Puede elegir tipo cosecha parcial, total o fallida",

      "farmIdPlaceholder":"Seleccione Granja",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "harvestedAtPlaceholder": "Fecha de cosecha",
      "statusPlaceholder": "Seleccione Tipo de cosecha",
      "weightPlaceholder": " ",
      "sizePlaceholder": " ",
      "pricePlaceholder": " ",
      "buyerPlaceholder": "Comprador",
      "remarkPlaceholder": "Nota",

      "full": "Completo",
      "partial": "Parcial",
      "failed": "Fallido",
      "harvest": "Cosecha",
    },
    "mortalityForm": {
      "farmId": "Granja",
      "cycleId": "Estanque",
      "recordedAt": "Fecha",
      "totalWeight": "Peso Total (kg)",
      "size": "Talla (tail/kg)",
      "multiplier": "Multiplicador",
      "quantityFinal": "Total de muertes (cola)",
      "multiplierInfo": "Predecir posibles muertes de camarones no identificados.",
      "files": "Fotos",
      "remark": "Notas (Opcional)",
      "mortalityTooltip": "Anote aquí los datos de mortalidad",
      "quantityPlaceholder": "0",

      "farmIdPlaceholder": "Seleccione Granja",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "recordedAtPlaceholder": "Seleccione Fecha",
      "totalWeightPlaceholder": "0",
      "sizePlaceholder": "0",
      "multiplierPlaceholder": "E.g. 1.5",
      "filesPlaceholder": "Fotos",
      "remarkPlaceholder": "Nota",

      "mortality": "Mortalidad",

      "averageWeight": "PP (g)",
      "quantity": "Cantidad Total (estimación)",
      "basedOn": "Residencia En",
      "basedOnQuantity": "Cantidad (piezas)",
      "basedOnSize": "Tamaño"
    },
    "chemicalMultiMeasurementForm": {
      "farmId": "Granja",
      "batchId": "Lote",
      "pondId": "Estanque",
      "cycleId": "Estanque",
      "measuredDate": "Fecha Medida",
      "measuredTime": "Tiempo Medido",
      "chemicalTooltip": "Anote los datos químicos aquí",

      "ammonia": "Amoníaco (NH3) (ppm)",
      "nitrat": "Nitrato (NO3) (ppm)",
      "nitrit": "Nitrito (NO2) (ppm)",
      "alkalinity": "Alcalinidad (ppm)",
      "hardness": "Dureza (ppm)",
      "calcium": "Calcio (Ca) (ppm)",
      "magnesium": "Magnesio (Mg) (ppm)",
      "carbonat": "Carbonato (CO3) (ppm)",
      "bicarbonat": "Bicarbonato (HCO3) (ppm)",
      "tom": "Materia Organica Total (TOM) (ppm)",
      "orp": "Potencial de reducción de oxidación (ORP) (mV)",
      "ammonium": "Amonio (NH4) (ppm)",
      "phosphate": "Fosfato (PO4) (ppm)",
      "totalAmmonia": "Amoníaco total (ppm)",
      "potassium": "Potasio (ppm)",

      "farmIdPlaceholder": "Seleccione Granja",
      "batchIdPlaceholder": "Seleccione Lote",
      "pondIdPlaceholder": "Seleccione Estanque",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "measuredDatePlaceholder": "Fecha Medida",
      "measuredTimePlaceholder": "Tiempo Medido",

      "ammoniaPlaceholder": "-",
      "nitratPlaceholder": "-",
      "nitritPlaceholder": "-",
      "alkalinityPlaceholder": "-",
      "hardnessPlaceholder": "-",
      "calciumPlaceholder": "-",
      "magnesiumPlaceholder": "-",
      "carbonatPlaceholder": "-",
      "bicarbonatPlaceholder": "-",
      "tomPlaceholder": "-",
      "orpPlaceholder": "-",
      "ammoniumPlaceholder": "-",
      "phosphatePlaceholder": "-",
      "totalAmmoniaPlaceholder": "-",
      "potassiumPlaceholder": "-",

      "chemical": "Químico"
    },
    "planktonMultiMeasurementForm": {
      "farmId": "Granja",
      "batchId": "Lote",
      "pondId": "Estanque",
      "cycleId": "Estanque",
      "measuredDate": "Fecha Medida",
      "measuredTime": "Tiempo Medido",
      "planktonTooltip": "Anote los datos del plancton aquí",

      "totalPlankton": "Plancton total (Total) (células/ml)",
      "ga": "Alga verde (GA) (células/ml)",
      "bga": "Alga verde azul (BGA) (células/ml)",
      "dino": "Dinoflagellata (DINO) (células/ml)",
      "diatom": "Diatom (células/ml)",
      "prozoo": "Protozoa (PRO) (células/ml)",
      "floc": "Floc (ml)",
      "gba": "Algas pardas doradas (GBA) (células/ml)",
      "euglenophyta": "Euglenophyta (células/ml)",
      "zoo": "Zoo (ZOO) (células/ml)",
      "haptyophyta": "Haptyophyta (células/ml)",
      "gga": "Algas verdes doradas (GGA) (células/ml)",
      "yga": "Algas verdes amarillas (YGA) (células/ml)",

      "farmIdPlaceholder": "Seleccione Granja",
      "batchIdPlaceholder": "Seleccione Lote",
      "pondIdPlaceholder": "Seleccione Estanque",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "measuredDatePlaceholder": "Fecha Medida",
      "measuredTimePlaceholder": "Tiempo Medido",

      "totalPlanktonPlaceholder": "-",
      "gaPlaceholder": "-",
      "bgaPlaceholder": "-",
      "dinoPlaceholder": "-",
      "diatomPlaceholder": "-",
      "prozooPlaceholder": "-",
      "flocPlaceholder": "-",
      "gbaPlaceholder": "-",
      "euglenophytaPlaceholder": "-",
      "zooPlaceholder": "-",
      "haptyophytaPlaceholder": "-",
      "ggaPlaceholder": "-",
      "ygaPlaceholder": "-",

      "plankton": "Plancton"
    },
    "microbiologyMultiMeasurementForm": {
      "farmId": "Granja",
      "batchId": "Lote",
      "pondId": "Estanque",
      "cycleId": "Estanque",
      "measuredDate": "Fecha Medida",
      "measuredTime": "Tiempo Medido",
      "microbiologyTooltip": "Anote los datos de microbiología aquí",

      "totalBacteria": "bacterias totales (CFU/ml)",
      "totalVibrio": "Vibrión total (CFU/ml)",
      "yellow": "Vibrio amarillo (CFU/ml)",
      "green": "Vibrión verde (CFU/ml)",
      "black": "Negro (CFU/ml)",
      "luminance": "Luminance (CFU/ml)",

      "farmIdPlaceholder": "Seleccione Granja",
      "batchIdPlaceholder": "Seleccione Lote",
      "pondIdPlaceholder": "Seleccione Estanque",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "measuredDatePlaceholder": "Fecha Medida",
      "measuredTimePlaceholder": "Tiempo Medido",

      "totalBacteriaPlaceholder": "-",
      "totalVibrioPlaceholder": "-",
      "yellowPlaceholder": "-",
      "greenPlaceholder": "-",
      "blackPlaceholder": "-",
      "luminancePlaceholder": "-",

      "microbiology": "Microbiología"
    },
    "cycleDiseaseForm" : {
      "farmId": "Granja",
      "cycleId": "Estanque",
      "loggedDate": "Fecha",
      "diseaseId": "Nombre de la enfermedad",
      "otherDisease": "Otro nombre de enfermedad",
      "files": "Fotos",
      "remark": "Notas (Opcional)",
      "diseaseTooltip": "Anote aquí el resultado de la prueba de enfermedad",
      "diseaseEvidence": "Subir foto de camarones infectados como nota adicional",

      "farmIdPlaceholder": "Seleccione Granja",
      "cycleIdPlaceholder": "Seleccione Estanque",
      "loggedDatePlaceholder": "Fecha",
      "diseaseIdPlaceholder": "Seleccionar enfermedad",
      "otherDiseasePlaceholder": "Otra enfermedad",
      "filesPlaceholder": "Fotos",
      "remarkPlaceholder": "Nota",

      "cycleDisease": "Enfermedad"
    },

    "simulationForm": {
      "name": "Datos del nombre de la simulación",
      "area": "Granja amplia (m²)",
      "date": "Fecha",
      "seed": "Semilla total",
      "periode": "Período de cosecha",
      "biomass": "Biomasa máxima (kg/m²)",
      "survival": "Stasa de supervivencia (%)",
      "size": "Tamaño en Días 100 (tail/kg)",
      "feed": "Precio de alimentación por kg",
      "shouldBeFilled": "Debe ser llenado",
      "shouldBeGreaterThan": "Debe ser mayor que {{value}}",
      "shouldBeLessThan": "Debe ser menor que {{value}}",
      "age": "Edad de entrada",
      "percent": "Porcentaje de entrada",
      "namePlaceholder": `Simulación ${moment().format('YYYY-MM-DD')}`,
      "areaPlaceholder": "1.000 m²",
      "datePlaceholder": "Elige fecha",
      "seedPlaceholder": "100.000 tails",
      "perioderPlaceholder": "120 days",
      "biomassPlaceholder": "1.2 kg/m²",
      "survivalPlaceholder": "100%",
      "sizePlaceholder": "45",
      "feedPlaceholder": "Rp 15.000",
      "agePlaceholder": "Edad de entrada",
      "percentPlaceholder": "Porcentaje de entrada"
    },

    "autoFeederDailyFeedForm": {
      "title": "Agregar Datos de Alimentación de Asto",
      "subtitle": "Detalles de Alimentación",
      "start": "Inicio",
      "end": "Fin",
      "quantity": "Alimento",
      "quantitycontinuous": "Alimentación Total Diaria",
      "remark": "Notas (Opcional)",
      "disclaimer": "Los datos de alimentación agregados en Asto estarán conectados con los datos de cultivo en JALA",
      
      "remarkPlaceholder": "#AutoFeeder",
      "ratio": "Proporción de alimentación"
    }
  }

